// extracted by mini-css-extract-plugin
module.exports = {"resultTitle":"allergy-test_resultTitle__KTngw","resultHeadline":"allergy-test_resultHeadline__FEF9m"};